import { MenuItem } from 'src/app/models/menu-item.model';

/** Rutas sin barra inicial; se navega con `navigateByUrl('/')`. */
export const DOC_NAV_MENU: MenuItem[] = [
  {
    label: 'Introducción',
    enabled: true,
    icon: 'home',
    route: 'main',
    children: null,
  },
  {
    label: 'Primeros pasos',
    enabled: true,
    icon: 'rocket_launch',
    route: 'getting-started',
    children: null,
  },
  {
    label: 'Librerías de pago',
    enabled: true,
    icon: 'integration_instructions',
    route: null,
    children: [
      {
        label: 'Web',
        enabled: true,
        icon: 'language',
        route: null,
        children: [
          {
            label: 'API 1‑click',
            enabled: true,
            icon: 'smart_button',
            route: 'integration/web/agoraweb',
            children: null,
          },
          {
            label: 'Tarjetas',
            enabled: true,
            icon: 'credit_card',
            route: 'integration/web/cards',
            children: null,
          },
          {
            label: 'Playground SDK',
            enabled: true,
            icon: 'biotech',
            route: 'integration/web/playground',
            children: null,
          },
          {
            label: 'Pago con QR',
            enabled: true,
            icon: 'qr_code_2',
            route: 'integration/web/react-sdk-qr',
            children: null,
          },
          {
            label: 'Pruebas funcionales',
            enabled: true,
            icon: 'fact_check',
            route: 'integration/web/functional-tests',
            children: null,
          },
        ],
      },
      {
        label: 'Flutter',
        enabled: true,
        icon: 'smartphone',
        route: null,
        children: [
          {
            label: 'API 1‑click',
            enabled: true,
            icon: 'smart_button',
            route: 'integration/flutter/agoraweb',
            children: null,
          },
          {
            label: 'Tarjetas',
            enabled: true,
            icon: 'credit_card',
            route: 'integration/flutter/cards',
            children: null,
          },
        ],
      },
    ],
  },
  {
    label: 'Referencias de API',
    enabled: true,
    icon: 'menu_book',
    route: null,
    children: [
      {
        label: 'API Link',
        enabled: true,
        icon: 'link',
        route: 'api/orders',
        children: null,
      },
      {
        label: 'Operaciones',
        enabled: true,
        icon: 'sync_alt',
        route: 'api/operations',
        children: null,
      },
      {
        label: 'Integración de pagos',
        enabled: true,
        icon: 'payments',
        route: 'api/payment',
        children: null,
      },
      {
        label: 'Eventos',
        enabled: true,
        icon: 'bolt',
        route: 'api/events',
        children: null,
      },
    ],
  },
];
